import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';

export interface AssignmentRule {
  id: string;
  name: string;
  description?: string;
  is_active: boolean;
  priority: number;
  market?: string;
  business_unit?: string;
  source?: string;
  origem?: string;
  target_department_id?: string;
  target_role_id?: string;
  assignment_strategy: 'round_robin' | 'random';
  target_deal_field?: 'sales_development' | 'sales_consultant';
  metadata?: {
    selected_user_ids?: string[];
    paused_user_ids?: string[];
    last_assigned_index?: number;
  };
  created_at: string;
  updated_at: string;
  target_department?: { id: string; name: string };
  target_role?: { id: string; name: string };
}

export const useAssignmentRules = () => {
  const { data: rules, isLoading, error } = useQuery({
    queryKey: ['assignment-rules'],
    queryFn: async () => {
      const { data, error } = await supabase
        .from('assignment_rules')
        .select(`
          *,
          target_department:departments(id, name),
          target_role:system_roles(id, name)
        `)
        .order('priority', { ascending: false });

      if (error) throw error;
      return data as AssignmentRule[];
    },
  });

  return { rules: rules || [], isLoading, error };
};
